import { Consultant } from './../../../models/Consultant.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { ResponsibleFinancial } from './../../../models/project/ResponsibleFinancial.model';
import { CompanyGroupsFinancial } from './../../../models/project/CompanyGroupsFinancial.model';
import { CompanyFinancial } from './../../../models/project/CompanyFinancial.model';
import { ProjectFinancialService } from './../../../services/projectFinancial.service';
import { ProjectFinancial } from './../../../models/project/ProjectFinancial.model';
import { TeamGroups } from './../../../models/teamGroups.model';
import { CommonHelper } from './../../../shared/helpers/CommonHelper';
import { DropDownList } from './../../../models/DropDownList.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef  } from '@angular/core';
import { Project } from '../../../models/Project.model';
import { AwsService } from '../../../services/aws.service';
import { CompaniesService } from '../../../services/companies.service';
import { SubDivision } from '../../../models/SubDivision.model';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { FilterBuilder } from '../../../shared/builders/filter.builder';
import { filterSelectByArrays } from "../../../shared/helpers/filter-select-items";

@Component({
  selector: 'app-project-create',
  templateUrl: './project-create.component.html',
  styleUrls: ['./project-create.component.css']
})
export class ProjectCreateComponent implements OnInit {
  @ViewChild('uploadInput') uploadInput:ElementRef;
  addProjectCheck: boolean = false;
  projectForm: FormGroup;
  loading: boolean;
  project: ProjectFinancial = new ProjectFinancial();
  companies: CompanyFinancial[] = new Array<CompanyFinancial>();
  responsibles: ResponsibleFinancial[] = new Array<ResponsibleFinancial>();
  companyGroups: CompanyGroupsFinancial[] = new Array<CompanyGroupsFinancial>();
  projectsHashTrack: Project[] = new Array<Project>();
  consultantsLoad: Consultant[] = new Array<Consultant>();
  teamGroups: TeamGroups[] = new Array<TeamGroups>();
  commonHelper: CommonHelper = new CommonHelper();
  selectedFiles:FileList;

  dropDownProjectshash: any;
  dropDownClient: any;
  dropDownGroup: any;
  dropDownResponsable: any;
  dropDownConsultant: any;
  dropDownTeamGroups: any;
  dropDownExcellenceCenters: any;

  dropDownListDivisions: DropDownList[] = new Array<DropDownList>();
  selectedDivisionsItems: DropDownList[] = new Array<DropDownList>();
  dropDownDivisionsSettings = {};

  dropDownSubDivisions: DropDownList[] = new Array<DropDownList>();
  selectedSubDivisionItems: DropDownList[] = new Array<DropDownList>();
  dropDownSubDivisionsSettings = {};
  subDivisions: SubDivision = new SubDivision();
  allSubDivisions: any = [];
  subDivisionsPerDivision: any = [];
  consultantsListAux: {id: string, itemName: string}[] = [];

  excellenceCenters: ExcellenceCenter[] = [];

  constructor(
              private formBuilder: FormBuilder,
              private projectsFinancial: ProjectFinancialService,
              private router: Router,
              public toastr: ToastsManager,
              private awsService: AwsService,
              private companiesService:CompaniesService,
              private filterBuilder: FilterBuilder,
              private excellenceCenterService: ExcellenceCentersService
              ) { }

  async ngOnInit() {
      this.loading = true;
      this.projectForm = this.formBuilder.group({
        name: [null, Validators.required]
      });

      await Promise.all([
        this.populateCompanyGroups(),
        this.populateCompanies(),
        this.populateResponsables(),
        this.populateProjectsHashTrack(),
        this.populateConsultants(),
        this.loadSubDivisions(),
        this.populateTeamGroups(),
        this.populateExcellenceCenters(),
      ]);


      this.dropDownSubDivisionsSettings = this.commonHelper.getDropDownSettings(true, 'Tipo de Serviço', false, 'Marcar todos os Tipos de Serviços', 'Desmarcar todos os Tipos de Serviços', true,null, '');
      this.closeLoad();
  }

  async populateCompanies() {
    let hasGroup = (this.dropDownGroup && this.dropDownGroup.selectedItems.length > 0) ? this.dropDownGroup.selectedItems[0].id : false;
    const res = await this.projectsFinancial.getAllCompany(hasGroup);
    this.companies = res;
    this.dropDownClient = this.projectsFinancial.createPropertyObjDropDown(this.companies, true, "Cliente", "clientes",['group'],'group');
    this.dropDownClient.dropDownList.forEach(item => item.group =  this.commonHelper.transcriptDivisionGroup(item.group));
    this.closeLoad();
  }

  async loadSubDivisions() {
    this.allSubDivisions = await this.filterBuilder.buildSubDivisionFilter();
    this.dropDownSubDivisions = this.allSubDivisions;
    this.closeLoad();
  }

  async populateExcellenceCenters() {
    const excellenceCenters = await this.excellenceCenterService.getAll();
    this.excellenceCenters = excellenceCenters.filter((c: ExcellenceCenter) => Number(c.type) == 1);
    this.dropDownExcellenceCenters = this.projectsFinancial.createPropertyObjDropDown(this.excellenceCenters, false, 'Centros', 'centros')
}

  async populateCompanyGroups() {
    const res = await this.projectsFinancial.getAllCompanyGroups();
    this.companyGroups = res;
    this.dropDownGroup = await this.projectsFinancial.createPropertyObjDropDown(this.companyGroups, true, "Grupos", "grupos");
    this.closeLoad();
  }

  async populateResponsables() {
    const res = await this.projectsFinancial.getAllResponsable();
    this.responsibles = res;
    this.dropDownResponsable = await this.projectsFinancial.createPropertyObjDropDown(this.responsibles, true, "Responsável", "responsáveis");
    this.closeLoad();
  }

  async populateProjectsHashTrack() {
    const res = await this.projectsFinancial.getAllProject();
    this.projectsHashTrack = res;
    this.dropDownProjectshash = await this.projectsFinancial.createPropertyObjDropDown(this.projectsHashTrack, false, "Projetos", "projetos");
    this.closeLoad();
  }

  async populateConsultants() {
    const res = await this.projectsFinancial.getAllConsultants();
    this.consultantsLoad = res;
    this.dropDownConsultant = await this.projectsFinancial.createPropertyObjDropDown(this.consultantsLoad, false, "Consultores", "consultores");
    this.consultantsListAux = [...this.dropDownConsultant.dropDownList];
    this.closeLoad();
  }

  async populateTeamGroups() {
    this.teamGroups = await this.projectsFinancial.getAllTeamGroups();
    this.dropDownTeamGroups = await this.projectsFinancial.createPropertyObjDropDown(this.teamGroups, false, "Grupos de Times", "Grupos de Times");
    this.closeLoad();
  }

  closeLoad() {
    if (this.companies.length > 0 && this.responsibles.length > 0 && this.projectsHashTrack.length > 0  && this.consultantsLoad.length > 0) {
        this.loading = false;
    }
  }

  cancel() {
      this.dropDownProjectshash.selectedItems = [];
      this.dropDownClient.selectedItems = [];
      this.dropDownResponsable.selectedItems = [];
      this.dropDownConsultant.selectedItems = [];
      this.dropDownTeamGroups.selectedItems = [];
      this.selectedDivisionsItems = [];
      this.dropDownExcellenceCenters.selectedItems = [];
      this.project = new ProjectFinancial();
      this.uploadInput.nativeElement.value = '';
  }

  onSubDivisionChange() {
    if(this.selectedSubDivisionItems.length > 0){
      let selectedSubDivision =  this.subDivisionsPerDivision.find(sub => sub.code == this.selectedSubDivisionItems[0].id)
      this.subDivisions.code = this.selectedSubDivisionItems[0].id;
      this.subDivisions.name = this.selectedSubDivisionItems[0].itemName;
      this.subDivisions.sapSubDivision = selectedSubDivision.sapSubDivision
    } else {
      this.subDivisions = new SubDivision();
    }
  }

  onChange() {
   if (this.dropDownResponsable.selectedItems.length > 0
        && this.dropDownGroup.selectedItems.length > 0
        && this.dropDownClient.selectedItems.length > 0
        && this.dropDownExcellenceCenters.selectedItems.length > 0
        && this.projectForm.valid) {
            this.addProjectCheck = true;
        } else {
            this.addProjectCheck = false;
        }
  }

  async save() {
      if(this.dropDownClient.selectedItems.length > 0)
        this.project.company = this.companies.find(fnd => fnd._id == this.dropDownClient.selectedItems[0].id);
      this.project.companyGroup = this.companyGroups.find(fnd => fnd._id == this.dropDownGroup.selectedItems[0].id);
      this.project.userResponsable = this.responsibles.find(fnd => fnd._id == this.dropDownResponsable.selectedItems[0].id);
      this.project.hashTrack = this.projectsHashTrack
            .filter(flt => this.dropDownProjectshash.selectedItems.find(fnd => fnd.id == flt._id) != null);
      if(this.dropDownTeamGroups.selectedItems.length > 0)
        this.project.teamGroups = this.dropDownTeamGroups.selectedItems.map(teamGroup => ({ _id: teamGroup.id, name: teamGroup.itemName }));

      try {
        if(this.project.name.length > 30)
          return this.toastr.warning('O nome do projeto é longo demais, permitido apenas 30 caracteres!');

        if (!this.dropDownExcellenceCenters.selectedItems.length)
          return this.toastr.warning('Selecione um ou mais Centros de Excelência para prosseguir com a criação do Projeto', 'Projeto');

        this.loading = true;
        let response = await this.projectsFinancial.create(this.project);
        if(response._id){
            this.loading = false;
          if(this.selectedFiles)
            this.upload(response._id);

          this.toastr.success('Projeto criado com sucesso!');
            this.router.navigate(['/projects']);
        } else {
          this.loading = false;
          let res = JSON.parse(response._body)
          this.toastr.warning(res.message);
        }
      } catch(err) {
        this.loading = false;
        console.log(err);
        this.router.navigate(['/projects']);
        this.toastr.warning('Erro Salvar Projeto!')
      }

  }
  OnCancel() {
    this.router.navigate(['/projects']);
  }

  verifyValidTouched(fieldName) {
    return !this.projectForm.get(fieldName).valid && this.projectForm.get(fieldName).touched;
  }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }

  selectFile(event) {
      this.selectedFiles = event.target.files;
  }

  addItem() {
    if(this.dropDownConsultant.selectedItems.length > 0 ) {
      const selectedConsultant = this.dropDownConsultant.selectedItems[0];
      const consultant = new Consultant();
      consultant._id = selectedConsultant.id;
      consultant.name = selectedConsultant.itemName;

      this.addConsultant(consultant);

      this.toastr.info(`O consultor "${consultant.name}" foi adicionado ao projeto!`, "Novo consultor")
      this.dropDownConsultant.selectedItems = [];
    }
  }

  refreshConsultantSelect = () => {
    const teamGroupIds = this.project.consultants.map((cons) => cons._id);
    this.dropDownConsultant.dropDownList = filterSelectByArrays(this.consultantsListAux, teamGroupIds);
  }

  addConsultant(consultant: Consultant) {
    let existsConsultant = this.project.consultants.findIndex(item => item._id == consultant._id);
    if(existsConsultant === -1){
      let newConsultant = this.consultantsLoad.find(c => c._id == consultant._id);
      if(newConsultant) {
        consultant.fcEmail = newConsultant.fcEmail;
        consultant.sapCardCode = newConsultant.sapCardCode;
        consultant.hashTrackId = newConsultant.hashTrackId;
        this.project.consultants.push(consultant);
        this.refreshConsultantSelect();
      }
    }

    this.sortConsultant();
  }

  sortConsultant() {
    this.project.consultants.sort((a, b) => {
        if(a.name > b.name) return 1;
        if(a.name < b.name) return -1;
        return 0;
    })
  }

  addItemGroup() {
    if(this.dropDownTeamGroups.selectedItems.length > 0) {

      let teamGroupsConsultants = [];
      const teamGroupsIds = this.dropDownTeamGroups.selectedItems.map(t => t.id);
      teamGroupsIds.forEach(tgId => {
        const teamGroup = this.teamGroups.find(t => t._id === tgId);
        teamGroupsConsultants = [...teamGroupsConsultants, ...teamGroup.consultants];
      });

      teamGroupsConsultants.forEach(c => {
        const consultant = new Consultant();
        consultant._id = c._id;
        consultant.name = c.name;

        this.addConsultant(consultant);
      });
      const [teamGroupName] = this.dropDownTeamGroups.selectedItems;
      this.toastr.info(`O Grupo "${teamGroupName.itemName}" foi adicionado no projeto!`, "Novo consultor")
    }
  }

  removeItem(i) {
    const consultantName =  this.project.consultants[i].name || "";
    this.project.teamGroups.splice(i, 1);
    this.project.consultants.splice(i, 1);

    this.refreshConsultantSelect();
    this.toastr.info(`O consultor "${consultantName}" foi removido do projeto!`);
  }

  upload(id) {
    let length = this.selectedFiles.length;
    for(let i=0; i<length; i++){
      const file = this.selectedFiles.item(i);
        this.awsService.uploadfile(file,id);
    }
  }

  clearCustomer(){
    this.dropDownClient.selectedItems = [];
    this.populateCompanies();
  }

  onCenterChange() {
    if (!!this.dropDownExcellenceCenters.selectedItems.length) {
        const centers = this.dropDownExcellenceCenters.selectedItems.map((center: DropDownList) => {
            return {
                    _id: center.id,
                    name: center.itemName
            } as ExcellenceCenter
        });
     this.project.excellenceCenters = [...centers];
     return;
    }
    this.project.excellenceCenters = new Array<ExcellenceCenter>();
  }

  async checkForExternalReference(){
    if(this.dropDownClient.selectedItems.length > 0){
      let _id = this.dropDownClient.selectedItems[0].id;
      let company = await this.companiesService.getById(_id);
      if(company){
        if(!company.externalReference){
          this.toastr.onClickToast()
                      .subscribe( toast => {
                        this.router.navigate([`/companies/companies-edit/${_id}`]);
                        this.toastr.dismissToast(toast);
                      });
                      this.toastr.error(`O cliente selecionado não possui vínculo com um cliente Hashtrack, projeto não será integrado com Hashtrack. Para vincular, clique aqui!`,'Cliente não mapeado!',{
                        toastLife:10000,
                        showCloseButton: true
                      });
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/projects/project-create/project-create.component.ts